<template>
  <a-layout>
    <!-- <s-header></s-header> -->
    <div class="container emailfinder">
      <div>
        <div class="search">
          <div class="logo"></div>
          <a-select size="large" v-model="searchType">
            <!-- <a-select-option v-for="(v,k) in listType" :key="k" :value="k">{{v}}</a-select-option> -->
            <a-select-option :value="1">公司名称</a-select-option>
            <a-select-option :value="2">邮箱号码</a-select-option>
          </a-select>

          <a-form class="searchFrm" :autoFormCreate="createSearchForm">

            <a-form-item fieldDecoratorId="email" :fieldDecoratorOptions="{rules:[{required:true}]}">
              <a-input size="large" style="width:500px;" @pressEnter="search1" name="email" :placeholder="searchType==1&&'请输入检索公司名称...'||'请输入检索邮箱地址...'" />
            </a-form-item>

          </a-form>
          <!-- <a-input size="large" style="width:500px;" @pressEnter="search" :v-validate="'required|email'" v-model="email" :class="{ 'is-danger': errors.has('email') }" name="email" :placeholder="searchType==1&&'请输入检索公司名称...'||'请输入检索邮箱地址...'" /> -->
          <a-button type="primary" size="large" @click="search1">搜索</a-button>
          <div class="userinfo">
            <img :src="accountInfo&&accountInfo.avatar||require('@/assets/img/avatar.png')">
          </div>
        </div>
      </div>
      <div class="content">
        <div class="dataList">
          <span v-show="type!=='detail'">共检索到
            <span class="red">{{totalcount}}</span>条数据</span>
          <div @click="showList" class="back" v-show="type==='detail'">
            <img src="~@/assets/img/back.png" />
          </div>
          <div class="recharge-tip" v-if="accountInfo&&accountInfo.emailfinder">
            <template v-if="accountInfo.interest=='registered'||accountInfo.interest=='registeredPlus'">
              <template v-if="!parseInt(accountInfo.emailfinder.count)&&!hideRechargeTip">
                当前无剩余可查询数据量，是否升级权益？ {{hideRechargeTip}}
                <a-button size="small" @click="()=>{$router.push({name:'dashboard'})}">去升级</a-button>
                <a-button size="small" @click="HideRechargeTip">忽略</a-button>
              </template>
              <div v-else style="color:#ff8500;">
                本周可搜索次数剩余<span :style="{color:accountInfo.emailfinder.scount>10&&'#999'||'#f00'}" v-html="accountInfo.emailfinder.scount"></span>，
                本周可查询数据剩余<span :style="{color:accountInfo.emailfinder.count>10&&'#999'||'#f00'}" v-html="accountInfo.emailfinder.count"></span>！
              </div>
            </template>
            <template v-if="accountInfo.interest=='exhibitor'">
              <template v-if="parseInt(accountInfo.emailfinder.count)||hideRechargeTip">
                <span style="color:#999;margin-right:20px;">
                  套餐有效期剩余：<span :style="{color:moment.unix(accountInfo.emailfinder.date).diff(moment(moment().format('YYYY-MM-DD')),'days')>7&&'#999'||'#f00'}" v-html="moment.unix(accountInfo.emailfinder.date).diff(moment(moment().format('YYYY-MM-DD')),'days')"></span>，
                  今日可查询数据剩余：<span :style="{color:accountInfo.emailfinder.count>10&&'#999'||'#f00'}" v-html="accountInfo.emailfinder.count"></span>！
                </span>
              </template>
              <template v-else>
                对不起，您当前已无可查询数据剩余，请明日再试！
                <a-button size="small" @click="HideRechargeTip">忽略</a-button>
              </template>
            </template>
            <!-- <template v-show="!hideRechargeTip" v-if="!moment.unix(accountInfo.emailfinder.date).diff(moment(moment().format('YYYY-MM-DD')),'days')">
              您的套餐已到期，请充值！
              <a-button size="small">去充值</a-button>
              <a-button size="small" @click="hideRechargeTip=true">忽略</a-button>
            </template>
            <template v-else>
              <span style="color:#999;margin-right:20px;">
                套餐有效期剩余：<span :style="{color:moment.unix(accountInfo.emailfinder.date).diff(moment(moment().format('YYYY-MM-DD')),'days')>7&&'#999'||'#f00'}" v-html="moment.unix(accountInfo.emailfinder.date).diff(moment(moment().format('YYYY-MM-DD')),'days')"></span>
                |
                今日可查询数据剩余：<span :style="{color:accountInfo.emailfinder.count>10&&'#999'||'#f00'}" v-html="accountInfo.emailfinder.count"></span>
              </span>
            </template> -->
          </div>
        </div>
        <div class="data-layout">
          <div class="list" v-show="type==='list'">
            <div class="ad ad_top">
              <img src="~@/assets/img/banner.jpg" />
            </div>
            <div class="data">
              <div class="data_detail" v-for="(v,i) in list" :key="i">
                <div class="name_time">
                  <div class="name">
                    <label>姓名：</label>
                    <label>
                      <a v-html="v.name" @click="showDetail(v)"></a>
                    </label>
                  </div>
                  <div class="time">
                    <label>更新时间：</label>
                    <label v-html="formatTime(v.updatetime)"></label>
                  </div>
                </div>
                <div class="position_msg">
                  <div>
                    <label>职务：</label>
                    <label v-html="v.position"></label>
                  </div>
                  <div>
                    <label>公司：</label>
                    <label v-html="v.company"></label>
                  </div>
                  <div>
                    <label>邮箱：</label>
                    <label v-html="v.email"></label>
                  </div>
                  <div>
                    <!-- <div>社交账号：</div>
                    <div v-show="v.linkedin">
                      <a :href="v.linkedin" target=_blank>
                        <div></div>
                      </a>
                    </div>&nbsp;
                    <div v-show="v.twitter">
                      <a :href="v.twitter" target=_blank>
                        <div></div>
                      </a>
                    </div> -->
                  </div>
                </div>
                <div class="profile">
                  <label>个人简介：</label>
                  <label v-html="v.profile"></label>
                </div>
                <div class="show-detail">
                  <label @click="showDetail(v)">查看详情>></label>
                </div>
              </div>
            </div>
            <div v-show="loading" class="loading">

              <a-spin>
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
              </a-spin>
              加载中,请稍等...

              <!-- <img src="~@/assets/img/loading.png"> -->
            </div>
            <div class="pagination" v-show="totalcount>10">
              <a-pagination v-model="pageNo" :total="totalcount" @change="changePageNo" />
            </div>
            <div class="nodata" v-if="list!=null&&list.length==0&&!loading">
              <p>未检索到<span v-html="email"></span>相关数据信息!</p>
              <div>
                温馨提示：
                <p>1 请检查您的输入是否正确</p>
                <p>2 更换新的词进行搜索吧。</p>
              </div>
            </div>
          </div>

          <div class="detail" v-show="type==='detail'">
            <div class="company">
              <label v-html="detail.company"></label>
              <div v-html="`更新时间：${formatTime(detail.updatetime)}`"></div>
            </div>
            <div class="person_detail">

              <div class="avatar">
                <img :src="detail.avatar||require('@/assets/img/avatar.png')" alt="">

                <a-button @click="attention">
                  <a-icon :type="detail.collectMsg&&detail.collectMsg.isCollect&&'star'||'star-o'" style="color:#ff6b6b;" />
                  {{detail.collectMsg&&detail.collectMsg.isCollect&&'已收藏 '||'收藏 '}}
                </a-button>
              </div>

              <div>
                <label>姓名：</label>
                <label v-html="detail.name"></label>
              </div>

              <div>
                <label>职位：</label>
                <label v-html="detail.position"></label>
              </div>

              <div v-if="!!detail.industry">
                <label>行业：</label>
                <label v-html="detail.industry"></label>
              </div>
              <div v-if="!!detail.country">
                <label>国家：</label>
                <label v-html="detail.country"></label>
              </div>
              <div v-if="!!detail.location">
                <label>位置：</label>
                <label v-html="detail.location"></label>
              </div>

              <div>
                <label>邮箱：</label>
                <label v-html="detail.email"></label>
                <a :data-clipboard-text="detail.email" class="copy-link">复制</a>
              </div>

              <div>
                <label>电话：</label>
                <label v-html="detail.phone"></label>
              </div>

              <div>
                <div class="social_account">社交账号：</div>
                <div class="social_facebook" v-show="detail.facebook">
                  <a :href="detail.facebook" target=_blank>
                    <div></div>
                  </a>
                </div>&nbsp;
                <div class="social_linkedin" v-show="detail.linkedin">
                  <a :href="detail.linkedin" target=_blank>
                    <div></div>
                  </a>
                </div>&nbsp;
                <div class="social_twitter" v-show="detail.twitter">
                  <a :href="detail.twitter" target=_blank>
                    <div></div>
                  </a>
                </div>
              </div>
            </div>

            <div class="person_brief">
              <div>个人简介:</div>
              <div v-html="detail.profile"></div>
            </div>

          </div>

          <div class="ad ad_right">
            <img src="~@/assets/img/ad2.jpg" />
          </div>
        </div>
      </div>

      <a-modal title="意见反馈" :visible="showFeedback" @ok="handleOk" @cancel="handleCancel" :footer="null">
        <a-form @submit="handleSubmit" :autoFormCreate="(form)=>{this.form = form;}">
          <template v-if="form">
            <a-form-item style="text-align:center;">
              意见反馈,对于采用的建议会给予一些奖励!
            </a-form-item>
            <a-form-item label="意见或建议" :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" fieldDecoratorId="feedback" :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入意见或建议' }]}">
              <a-textarea placeholder="请输入意见或建议" :autosize="{ minRows: 4, maxRows: 6 }" />
            </a-form-item>
            <a-form-item label="联系方式" :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
              <a-input placeholder='请输入电话或邮箱'> </a-input>
            </a-form-item>
            <a-form-item style="text-align:center;">
              <a-button type='primary' htmlType='submit' :disabled="hasErrors(form.getFieldsError())">
                提交
              </a-button>
            </a-form-item>
          </template>
        </a-form>
      </a-modal>
    </div>
  </a-layout>
</template>

<script>
import ClipboardJS from "clipboard";
var clipboard = new ClipboardJS(".copy-link");
import UpgradeTip from "../UpgradeTip";
import Header from "@/components/layout/Header";
import io from "socket.io-client";
import * as moment from "moment";

const limit = 10;
Array.prototype.removeByValue = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) {
      this.splice(i, 1);
      break;
    }
  }
};

var mergePerson = function(newvalue, oldvalue) {
  var mergevalue = oldvalue;
  !!newvalue.name && (mergevalue.name = newvalue.name);
  !!newvalue.position && (mergevalue.position = newvalue.position);
  !!newvalue.department && (mergevalue.department = newvalue.department);
  !!newvalue.company && (mergevalue.company = newvalue.company);
  !!newvalue.facebook && (mergevalue.facebook = newvalue.facebook);
  !!newvalue.twitter && (mergevalue.twitter = newvalue.twitter);
  !!newvalue.linkedin && (mergevalue.linkedin = newvalue.linkedin);
  !!newvalue.phone && (mergevalue.phone = newvalue.phone);
  !!newvalue.profile && (mergevalue.profile = newvalue.profile);
  !!newvalue.updatetime && (mergevalue.updatetime = newvalue.updatetime);
  return mergevalue;
};

export default {
  name: "search",
  components: {
    "s-header": Header
  },
  mounted() {
    clipboard.on("success", e => {
      this.$message.success("复制成功");
      e.clearSelection();
    });
  },
  data() {
    return {
      searchForm: null,
      searchType: 2,
      hideRechargeTip: false,
      verifyCode: "",
      form: false,
      showFeedback: false,
      email: "",
      type: "list",
      detail: {},
      loading: false,
      list: null,
      msgid: "",
      pageNo: 1,
      totalcount: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.searchType = parseInt((to.query && to.query.st) || 1);
      // vm.email=to.query&&to.query.search||'';
    });
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    HideRechargeTip() {
      this.$cookies.set("hideRechargeTip", true, "7d", "/");
      this.hideRechargeTip = true;
    },
    attention() {
      console.log(this.detail);
      this.$http
        .post(
          "/keyPersonCollect",
          Object.assign(
            {
              type: !this.detail.collectMsg.isCollect + 0
            },
            (this.detail.collectMsg.isCollect && {
              kid: this.detail.collectMsg.kid
            }) || {
              name: this.detail.name,
              position: this.detail.position,
              avatar: this.detail.avatar,
              company: this.detail.company,
              introduction: this.detail.profile,
              email: this.detail.email,
              facebook: this.detail.facebook,
              twitter: this.detail.twitter,
              linkedin: this.detail.linkedin,
              phone: this.detail.phone,
              industry: this.detail.industry,
              country: this.detail.country,
              location: this.detail.location
            }
          )
        )
        .then(res => {
          if (!res.error) {
            this.detail.collectMsg.isCollect = !this.detail.collectMsg
              .isCollect;
            this.detail.collectMsg.kid = res.data.kid;
          }
        });
    },
    createSearchForm(searchForm) {
      this.searchForm = searchForm;
      setTimeout(() => {
        searchForm.setFieldsValue({ email: this.$route.query.search || "" });
        if (this.$route.query.search != "") {
          this.search();
        }
      }, 50);
    },
    hasErrors(fieldsError) {
      return Object.keys(fieldsError).some(field => fieldsError[field]);
    },
    feedbackError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("feedback") && getFieldError("feedback");
    },
    feedback() {
      this.showFeedback = true;
    },
    handleOk() {},
    handleCancel() {
      this.showFeedback = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          //   console.log("Received values of form: ", values);
          // } else {
          //   console.log(err);
          //   console.log(this.form.getFieldsError());
        }
      });
    },
    search1() {
      this.pageNo = 1;
      return this.search();
    },
    search() {
      this.type = "list";
      this.searchForm.validateFields((err, values) => {
        if (
          this.searchType == 1 &&
          !!values.email.match(/([\u4e00-\u9fa5])+/g)
        ) {
          return this.$message.error("请使用英文输入");
        }
        var g = JSON.parse(this.$cookies.get("guest")) || [];
        if (
          !this.accountInfo &&
          ((g.length >= 5 && !g.some(f => f == values.email)) ||
            this.pageNo != 1)
        ) {
          this.pageNo = 1;
          return this.$loginFrm();
        }

        if (!err) {
          if (!this.accountInfo) {
            if (!g.some(f => f == values.email)) {
              g.push(values.email);
            }
            this.$cookies.set(
              "guest",
              JSON.stringify(g),
              new Date(
                this.moment()
                  .add(1, "days")
                  .format("L")
              ),
              "/"
            );
          }
          this.list = [];
          this.msgid = `${Date.parse(new Date())}`;

          this.$router.push({
            name: "search",
            query: {
              st: this.searchType,
              search: values.email,
              pageno: this.pageNo
            }
          });
          this.email = values.email;
          this.loading = true;

          this.socket.emit("get", {
            type: (this.searchType == 1 && "company") || "email",
            condition: values.email,
            msgid: this.msgid,
            token: this.$cookies.get("access-token") || "",
            limit: limit,
            offset: (this.pageNo - 1) * limit
          });
        } else {
          this.$message.error(
            (this.searchType == 1 && "公司名称不能为空") || "邮箱地址不能为空"
          );
        }
      });
      // this.$validator.validateAll().then(res => {
      //   if (res) {
      //     this.list = [];
      //     this.msgid = `${Date.parse(new Date())}`;

      //     this.$router.push({
      //       name: "search",
      //       query: { email: this.email, pageno: this.pageNo }
      //     });

      //     this.loading = true;

      //     this.socket.emit("get", {
      //       type: this.searchType==1&&'company'||"email",
      //       condition: this.email,
      //       msgid: this.msgid,
      //       token: this.$cookies.get("access-token") || "",
      //       limit: limit,
      //       offset: (this.pageNo - 1) * limit
      //     });
      //   } else {
      //     this.$message.error("请输入正确格式的邮箱");
      //   }
      // });
    },
    changePageNo(pageNo, pageSize) {
      this.pageNo = pageNo;
      this.limit = pageSize;
      this.search();
    },
    showDetail(data) {
      if (!this.accountInfo) {
        return this.$loginFrm();
      }

      this.socket.emit(
        "detail",
        {
          msgid: this.msgid,
          token: this.$cookies.get("access-token") || "",
          pid: data.pid
        },
        res => {
          this.type = "detail";
          console.log("detail:", res);
          this.detail = res;
          this.$refreshAccountInfo();
        }
      );

      // this.type = "detail";
      // this.detail = data;
    },
    showList() {
      this.type = "list";
      this.detail = {};
    },
    formatTime(t) {
      return (t && moment.unix(t).format("YYYY-MM-DD")) || "";
    }
  },
  created() {
    this.hideRechargeTip = this.$cookies.get("hideRechargeTip");
    this.email = this.$route.query.email;
    this.pageNo = parseInt(this.$route.query.pageno || 1);
    this.connect = false;
    console.log("create socket");
    this.socket = io("wss://teapi.showguide.cn", {
      path: "/socket.io",
      transports: ["websocket"],
      secure: true
    });
    // this.socket = io("http://192.168.1.222:3000");
    //this.socket = io("http://localhost:3000");
    var socket = this.socket;

    socket.on("connect", () => {
      console.log("connect");
      this.connect = true;
    });

    socket.on("disconnect", () => {
      console.log("disconnect");
      this.connect = false;
    });

    socket.on("apierror", err => {
      this.$refreshAccountInfo();
      console.log("apierror", err);

      /* 
        关键人
          无搜索次数:untimes
          无查询次数:upgrade
      */

      switch (err.code) {
        case 404:
        case 500:
          this.$message.error(err.desc);
          break;
        case 406:
          return this.$dialog(UpgradeTip, {
            tipType:
              (this.accountInfo.interest == "exhibitor" && "unstimes") ||
              "supgrade",
            accountInfo: this.accountInfo
          });
        default:
          return this.$dialog(UpgradeTip, {
            tipType:
              (this.accountInfo.interest == "exhibitor" && "untimes") ||
              "upgrade",
            accountInfo: this.accountInfo
          });
      }
    });

    socket.on("push", data => {
      console.log("push", data);
      this.$refreshAccountInfo();
      if (this.msgid !== data.meta.params.msgid) {
        this.loading = false;
        return;
      }
      this.loading = !data.last;
      // this.loading = false;
      this.list = [...data.data];
      this.totalcount = data.meta.results;
      // var oldlist = [...this.list];
      // var newlist = [...data.data];
      // data.data.forEach(d => {
      //   var t = oldlist.findIndex(l => l.email == d.email);
      //   !!~t &&
      //     (oldlist[t] = mergePerson(d, oldlist[t])) &&
      //     newlist.removeByValue(d);
      // });
      // this.list = [...oldlist, ...newlist];
    });

    socket.on("update", data => {
      console.log("update", data);
      if (this.msgid !== data.params.msgid) {
        return;
      }
      data.data.forEach(d => {
        var t = this.list.findIndex(l => l.email == d.email);
        !!~t && (this.list[t] = mergePerson(d, this.list[t]));
      });
      this.list = [...this.list];
    });

    this.socket.open();

    // if (!!this.email) {
    //   this.search();
    // }
  }
};
</script>

<style lang="scss" >
@import "~@/components/layout/style/mixin.scss";
.container.emailfinder {
  min-width: 1200px;
  background-color: #fff;
  & > div:first-child {
    background-color: rgb(233, 238, 242);
  }
  .searchFrm /deep/ .ant-form-item {
    margin: 0;
  }
  .search {
    margin: 0 auto;
    width: 1200px;
    height: 70px;
    background-color: rgb(233, 238, 242);
    padding-top: 10px;
    .searchFrm {
      display: inline-block;
      .ant-form-explain {
        display: none;
      }
    }
    & /deep/ .ant-select,
    & /deep/ .ant-select-selection,
    & /deep/ .ant-input,
    & /deep/ .ant-btn {
      vertical-align: middle;
      border-radius: 0;
    }
    .ant-btn {
      width: 110px;
    }
    & > div {
      display: inline-block;
      vertical-align: middle;
    }
    .userinfo {
      width: 300px;
      text-align: right;
      // margin-left: 200px;
      img {
        vertical-align: top;
        margin: 0;
        border-radius: 50%;
        width: 45px;
        height: 45px;
        padding: 0;
        @include intop-icon;
        background-position: -308px -1px;
      }
      &:after {
        display: inline-block;
        content: " ";
        @include intop-icon;
        width: 150px;
        height: 45px;
        background-position: -40px -528px;
      }
    }
    .logo {
      width: 150px;
      height: 40px;
      @include intop-icon;
      background-position: -40px -318px;
    }
  }

  .content {
    width: 1200px;
    margin: auto;
    font-size: 1.2em;
    .data-layout {
      display: flex;
    }
    .dataList {
      font-size: 12px;
      line-height: 32px;
      text-align: left;
      // padding-left: 135px;
      width: 100%;
      height: 32px;
      border-bottom: 1px solid rgb(222, 222, 222);
      .red {
        color: red;
        font-weight: bold;
      }
      .back {
        display: inline-block;
        // margin-left: 800px;
      }
      .recharge-tip {
        float: right;
        color: #f2352f;
        button {
          margin: 0 2px;
          border-radius: 20px;
          width: 70px;
          font-size: 12px;
          border: 0;
          &:nth-child(1) {
            color: #fff;
            background: #ff6b6b;
          }
          &:nth-child(2) {
            color: #999;
            background: #e8e8e8;
          }
        }
      }
    }
    & > div {
      vertical-align: top;
    }
    .list,
    .detail {
      display: inline-block;
      width: 957px;
      margin: auto 10px;
      text-align: left;
      min-height: 668px;
    }
    .list {
      padding-top: 30px;
      margin-right: 40px;
      .pagination {
        margin: 0 0 40px 0;
        text-align: center;
      }
      .nodata {
        margin: 40px 0 0 0;
        & > p {
          font-size: 16px;
          margin: 0 0 5px 0;
          color: #333;
          & > span {
            color: red;
          }
        }
        & > div {
          font-size: 12px;
          color: #999;
          & > p {
            margin: 5px 20px;
          }
        }
      }
    }
    .detail {
      width: 959px;
      margin-right: 40px;
      div {
        display: block;
        line-height: 29px;
        min-height: 29px;
        color: rgb(102, 102, 102);
        label:first-child {
          font-weight: bold;
        }
      }
      .company {
        border-bottom: 1px solid #dfe5eb;
        padding-top: 15px;
        height: 65px;
        line-height: 50px;
        font-size: 20px;
        font-weight: bold;
        padding-left: 5px;
        div {
          float: right;
          margin-top: 15px;
          margin-right: 20px;
          color: #bababa;
          font-weight: normal;
          font-size: 12px;
        }
      }
      .person_detail {
        min-height: 142px;
        font-size: 13px;
        border-bottom: 1px solid #dfe5eb;
        padding: 12px 5px;
        & > div {
          label:nth-child(2) {
            color: #666;
          }
          .copy-link {
            margin-left: 10px;
            font-size: 12px;
            &::before {
              content: " ";
              display: inline-block;
              width: 20px;
              height: 18px;
              @include intop-icon;
              background-position: -455px -655px;
              vertical-align: text-bottom;
            }
          }
        }
        .avatar {
          float: right;
          margin: 10px;
          img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            margin: auto;
            display: block;
          }
          & /deep/ .ant-btn {
            margin: 20px 0 0 0;
            border-radius: 50px;
            background-color: #f9f9f9;
          }
        }
        .social_account {
          font-weight: bold;
          line-height: 29px;
          display: inline-block;
          height: 29px;
        }
        .social_linkedin {
          width: 29px;
          height: 29px;
          display: inline-block;
          background: url("~@/assets/img/linkedin.png");
          background-size: 100% 100%;
        }
        .social_twitter {
          width: 29px;
          height: 29px;
          display: inline-block;
          background: url("~@/assets/img/twitter.png");
          background-size: 100% 100%;
        }
        .social_facebook {
          width: 29px;
          height: 29px;
          display: inline-block;
          background: url("~@/assets/img/facebook.png");
          background-size: 100% 100%;
        }
      }
      .person_brief {
        font-size: 13px;
        padding-top: 15px;
        div:first-child {
          color: rgb(102, 102, 102);
          font-weight: bold;
        }
        div:nth-child(2) {
          color: black;
        }
      }
    }

    text-align: center;
    .data {
      .data_detail {
        width: 959px;
        min-height: 100px;
        margin-top: 30px;
        .name_time {
          .name {
            font-size: 13px;
            width: 210px;
            display: inline-block;
            label:first-child {
              font-weight: bold;
              // color: rgb(0, 140, 214);
            }
            label:nth-child(2) {
              color: rgb(242, 53, 47);
            }
          }
          .time {
            font-size: 12px;
            display: inline-block;
            color: rgb(153, 153, 153);
          }
        }
        .profile {
          padding-top: 10px;
          label:first-child {
            display: inline-block;
            width: 80px;
            color: #666;
            font-size: 13px;
            font-weight: bold;
            vertical-align: top;
          }
          label:nth-child(2) {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            height: 19px;
            vertical-align: top;
            display: inline-block;
            width: 800px;
            word-break: break-all;
            vertical-align: top;
            color: #333;
            font-size: 13px;
          }
          // border-bottom: 1px solid rgb(222, 222, 222);
          // overflow: hidden;
          // font-size: 13px;
          // line-height: 20px;
          // height: auto;
          // max-height: 40px;
          // padding-top: 2px;
          // padding-bottom: 3px;
        }
        .show-detail {
          // margin-left: 80px;
          label {
            color: #008cd6;
            font-size: 12px;
          }
        }
        .position_msg {
          font-size: 13px;
          line-height: 30px;
          height: 30px;
          border-bottom: 1px solid rgb(222, 222, 222);
          div {
            display: inline-block;
            color: rgb(102, 102, 102);
          }
          div:first-child {
            width: 210px;
            height: 30px;
            overflow: hidden;
            label:first-child {
              font-weight: bold;
            }
          }
          div:nth-child(2) {
            width: 220px;
            height: 30px;
            overflow: hidden;
            label:first-child {
              font-weight: bold;
            }
          }
          div:nth-child(3) {
            width: 250px;
            height: 30px;
            overflow: hidden;
            label:first-child {
              font-weight: bold;
            }
          }
          div:nth-child(4) {
            overflow: hidden;
            width: 200px;
            height: 30px;
            padding-left: 3px;
            div:first-child {
              font-weight: bold;
              display: inline-block;
              width: 70px;
            }
            div:nth-child(2) {
              margin-left: 10px;
              margin-bottom: 5px;
              width: 20px;
              height: 20px;
              display: inline-block;
              background: url("~@/assets/img/linkedin.png");
              background-size: 100% 100%;
              div {
                width: 28px;
                height: 28px;
              }
            }
            div:nth-child(3) {
              margin-left: 10px;
              margin-bottom: 5px;
              width: 20px;
              height: 20px;
              display: inline-block;
              background: url("~@/assets/img/twitter.png");
              background-size: 100% 100%;
              div {
                width: 28px;
                height: 28px;
              }
            }
          }
          div:nth-child(5) {
            overflow: hidden;
            width: 50px;
            height: 30px;
            padding-left: 3px;
            color: rgb(0, 140, 214);
          }
        }
      }
    }
  }
  .loading {
    margin: 20px 400px;
  }
  .ad_top {
    display: inline-block;
    height: 80px;
    width: 959px;
  }
  .ad_right {
    display: inline-block;
    padding-top: 30px;
    height: 300px;
    width: 200px;
    right: 0px;
    top: 0;
  }
}
</style>

